import React from 'react';
import LinkList from '@ratedpeople/link-list';
import JobFormEntry from '@ratedpeople/job-form-entry';
import mobileGreaseImage from './elbow-grease-mobile.jpg';
import style from './style.module.scss';
var links = [{
  display: 'Homepage',
  href: '/'
}, {
  display: 'Blog',
  href: '/blog'
}, {
  display: 'Log-in',
  href: '/account/login'
}];
var defaultProps = {
  jopoBasePath: '/post-a-job'
};

var ErrorNotFound = function ErrorNotFound(_ref) {
  var jopoBasePath = _ref.jopoBasePath,
      restApiHostname = _ref.restApiHostname;
  return /*#__PURE__*/React.createElement("div", {
    className: style['error-not-found']
  }, /*#__PURE__*/React.createElement("div", {
    className: style['error-not-found_inner']
  }, /*#__PURE__*/React.createElement("div", {
    className: style['error-not-found_inner_content']
  }, /*#__PURE__*/React.createElement("h1", {
    className: style['error-not-found_inner_title']
  }, "Sorry, the thing you're looking for doesn't exist."), /*#__PURE__*/React.createElement("div", {
    style: {
      textAlign: 'center'
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: mobileGreaseImage,
    className: style['error-not-found_inner_content_img'],
    alt: "mobile grease"
  })), /*#__PURE__*/React.createElement("p", {
    className: style['error-not-found_inner_subtitle']
  }, "Here's some links to get you back on track:"), /*#__PURE__*/React.createElement(LinkList, {
    size: "large",
    links: links
  }), /*#__PURE__*/React.createElement(JobFormEntry, {
    basePath: jopoBasePath,
    restApiHostname: restApiHostname
  }))));
};

ErrorNotFound.defaultProps = defaultProps;
export default ErrorNotFound;